const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

function mergeUnknownWithDefaults(value: unknown, defaults: unknown): unknown {
  if (value === null || value === undefined) {
    return defaults;
  }

  if (typeof defaults === 'string') {
    return typeof value === 'string' && value.trim().length > 0 ? value : defaults;
  }

  if (Array.isArray(defaults)) {
    return Array.isArray(value) && value.length > 0 ? value : defaults;
  }

  if (isRecord(defaults)) {
    const valueRecord = isRecord(value) ? value : {};
    const result: Record<string, unknown> = {};

    for (const [key, defaultValue] of Object.entries(defaults)) {
      result[key] = mergeUnknownWithDefaults(valueRecord[key], defaultValue);
    }

    return result;
  }

  if (typeof defaults === 'number' || typeof defaults === 'boolean') {
    return typeof value === typeof defaults ? value : defaults;
  }

  return value;
}

export function mergeContentWithDefaults<T>(value: T | null | undefined, defaults: T): T {
  return mergeUnknownWithDefaults(value, defaults) as T;
}
